<template>
  <div>
    <div class="content_container main_width">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [],
      activeMenu: '',
    };
  },
  mounted() {
    this.menuList = this.$router.options.routes;
    this.activeMenu = this.$route.path;
  },
};
</script>

<style lang="less">
@import url('./plugin/hack.less');
@import url('./plugin/local-font.less');
* {
  padding: 0;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif;
  box-sizing: border-box;
}
html,
a,
div,
span {
  font-size: 14px;
}
.main_width {
  width: 100%;
  margin: 0 auto;
  // margin-left: -10px;
  //   margin-right: -10px;
  padding: 0 10px;
  box-sizing: border-box;
  overflow: hidden;
}
h3.nav {
  font-weight: bold;
}
.el-header {
  // padding: 5px 0;
  // border-bottom: 1px solid #eaeaea;
  background: #1c2260;
  color: #fff;
  line-height: 60px;
}
.content_container {
  min-height: 80vh;
}

.sidebar {
  width: 100%;
  border-right: 1px solid #eaeaea;
  min-height: 100vh;
  background: #fff;
  a {
    display: block;
    font-size: 14px;
    text-decoration: none;
  }
  ul {
    padding: 0;
    margin: 0;
    li {
      display: flex;
      align-items: center;
      // padding-left: 20px;
      padding: 0 10px;
      color: #212b36;
      justify-content: start;
      margin-top: 10px;
      i {
        font-size: 18px;
        margin-right: 10px;
        color: #333;
        // margin-bottom: 18px;
        vertical-align: text-bottom;
      }
      a {
        display: block;
        width: 100%;
        font-size: 14px;
        border-radius: 3px;
      }
    }
  }
}

.el-main {
  width: 100%;
  background: #fafafa;
}

.nav_menu_item {
  display: inline-block;
  color: #333;
  padding: 8px 20px;
  border-bottom: 1px solid #00000000;
  // margin-right: 20px;
  font-size: 14px;
  // margin-bottom: 16px;
}

.router-link-active {
  border-color: #333;
  color: #333;
  // font-weight: 600;
  background: #1c2260;
  color: #fff;
  i {
    color: #fff !important;
  }
}
.bg_color_gray {
  background-color: #fafafa;
}
.wrap {
  border-bottom: 1px solid #eaeaea;
  // background: green;
  a {
    text-decoration: none;
  }
}
.content_container {
  // padding: 10px 0 100px 0;
}
h3.page_title {
  padding-bottom: 10px;
  font-weight: 600;
  font-size: 20px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
}
.page_container {
  max-width: 100%;
  width: 1440px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.card {
  border: 1px solid #eaeaee;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
}
.mt20 {
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-start {
  justify-content: flex-start;
}
.flex-center {
  justify-content: center;
}
.el-pagination {
  margin: 40px auto auto -10px;
}
</style>
